import { StatsAdapterInterface } from '../../../stats/adapter.interface';
import { CategoryType } from '../types';

export class GtmStatsAdapterCategory implements StatsAdapterInterface {
  /**
   * Mapping category identifier to category type
   */
  private mapping: { [key: string]: CategoryType } = {
    buy: 'Residential for Sale',
    rent: 'Residential for Rent',
    commercial_buy: 'Commercial for Sale',
    commercial_rent: 'Commercial for Rent',
  };

  /**
   *
   * @param categoryIdentifier
   */
  constructor(private categoryIdentifier: string) {}

  /**
   * @inheritDoc
   */
  public getData(): CategoryType | string {
    return this.mapping[this.categoryIdentifier] || '';
  }
}
